import { city } from './city'
import { weather } from './weather'

export const api = Object.freeze({
  city,
  weather,
})
